import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgDatepickerComponent } from './ng-datepicker.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
  declarations: [NgDatepickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    PerfectScrollbarModule
  ],
  exports: [
    NgDatepickerComponent,
    CommonModule,
    FormsModule,
  ]
})
export class ShNgDatepickerModule {}
